import {FC, PropsWithChildren} from 'react';
import {ResursLoading} from '../ResursLoading/ResursLoading';
import {Visibility} from './Visibility';

export const VisibilityLoading: FC<
  PropsWithChildren<{
    isLoading?: boolean;
  }>
> = ({isLoading, children}) => {
  return (
    <Visibility visible={!isLoading} replacement={<ResursLoading />}>
      {children}
    </Visibility>
  );
};
